<template>
    <div class="space-y-6">
        <div class="grid grid-cols-2 gap-4">
            <div>
                <div class="space-y-4">
                    <DsMoneyInput
                        v-model="defaultTextValue"
                        label="Default"
                    />
                    <DsMoneyInput
                        v-model="prefixTextValue"
                        label="With Prefix"
                        :moneyConfig="{ prefix: '$' }"
                    />
                    <DsMoneyInput
                        v-model="negativeTextValue"
                        label="Disable Negative"
                        :moneyConfig="{ prefix: '$', disableNegative: true }"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import DsMoneyInput from '@ds/form/input/DsMoneyInput.vue';
import { ref } from 'vue';

const defaultTextValue = ref(100);
const prefixTextValue = ref(1000);
const negativeTextValue = ref(10000);
</script>
